export default __webpack_public_path__ + "static/media/NW0050.34I-42157_-25363_0.92d20b4b.jpg";